import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { ReportStatus } from '../../../shared/domain/reportStatus/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/reportStatuses' }

type Params = never
type Body = never
type Query = { lastSyncTime?: Date }
type Output = { reportStatuses: Array<ReportStatus & { tags: string[] }>; syncTime: Date }

export type GetallEndpoint = Endpoint<Params, Body, Query, Output>

export const getAll = (request: Request, args: RequestArgs<GetallEndpoint>) => request<GetallEndpoint>(route, args)
